import { Component } from '@angular/core';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { ModalController } from '@ionic/angular';
import { Platform } from '@angular/cdk/platform';

@Component({
  selector: 'app-splash',
  templateUrl: './splash.component.html',
  styleUrls: ['./splash.component.scss'],
})
export class SplashComponent  {

  constructor(public viewCtrl: ModalController, public splashScreen: SplashScreen,private platform: Platform,) { }

  ionViewDidEnter() {
   if(this.platform.ANDROID){
      this.splashScreen.hide();
      setTimeout(() => {
        this.viewCtrl.dismiss();
      }, 4520);

  }
}

}
